import PageTitle from "@app/components/page-title.tsx";
import MutationStatusRouter from "@app/components/status/mutation-status-router.tsx";
import useUserData from "@app/data-hooks/use-user-data.ts";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

interface SearchParams {
    uid?: string;
    token?: string;
}

export const Route = createFileRoute("/account/confirm-email")({
    component: Component,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            uid: search.uid as string | undefined,
            token: search.token as string | undefined,
        };
    },
});

function Component() {
    const { uid, token } = Route.useSearch();
    const { confirmEmail } = useUserData();

    const submitted = useRef(false);

    useEffect(() => {
        if (!uid || !token || submitted.current) {
            return;
        }
        submitted.current = true;
        confirmEmail.mutate({ userId: uid, post: { token } });
    }, [uid, token]);

    return (
        <>
            <PageTitle>Confirm Email</PageTitle>
            <MutationStatusRouter mutationHook={confirmEmail}>
                <Navigate to={"/"} />
            </MutationStatusRouter>
        </>
    );
}
